import axiosInstance from "./axiosInstance";

export interface VisaFeeApi {
  publicId: string;
  nationalities: string;
  effectiveFrom: string;
  effectiveTo: string;
  infantFee: number;
  childFee: number;
  adultFee: number;
  seniorFee: number;
  currency: string;
  status: boolean;
}

export interface VisaFeeListResponse {
  items: VisaFeeApi[];
  totalCount: number;
}

export interface VisaFeeListQuery {
  nationality?: string | null;
  status?: boolean | null;
  effectiveStartDate?: string | null;
  effectiveEndDate?: string | null;
  pageNo: number;
  pageSize: number;
}

export interface CountryApi {
  countryId: number;
  countryName: string;
  nationality?: string;
  iso2: string;
  iso3: string;
  dialCode: string;
  isActive: boolean;
}

export interface BaseCurrencyApi {
  currencyId: number;
  currencyCode: string;
  currencyName: string;
  currencySymbol: string;
  exchangeRate: number;
  isBaseCurrency: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateVisaFeePayload {
  nationalities: string[];
  effectiveFrom: string;
  effectiveTo: string;
  infantFee: number;
  childFee: number;
  adultFee: number;
  seniorFee: number;
  currency: string;
  status: boolean;
  createdBy: number;
}

export interface UpdateVisaFeePayload {
  publicId: string;
  nationalities: string[];
  effectiveFrom: string;
  effectiveTo: string;
  infantFee: number;
  childFee: number;
  adultFee: number;
  seniorFee: number;
  currency: string;
  status: boolean;
  updatedBy: number;
}

export interface CreateVisaFeeResponse {
  success: boolean;
  message: string;
  data: string;
  errors: string[];
}

export interface AgeRuleApi {
  ageRuleId: number;
  categoryName: string;
  minAge: number;
  maxAge: number;
  moduleId: number;
  isActive: boolean;
}

export const getAuthHeader = () => { 
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getVisaFees = async (
  params: VisaFeeListQuery
): Promise<VisaFeeListResponse> => {
  const { data } = await axiosInstance.get("/visa-fee/search", {
    params: {
      Nationality: params.nationality,
      Status: params.status,
      EffectiveStartDate: params.effectiveStartDate,
      EffectiveEndDate: params.effectiveEndDate,
      PageNo: params.pageNo,
      PageSize: params.pageSize,
    },
    headers: getAuthHeader(),
  });

  return {
    items: data.data.data,
    totalCount: data.data.totalRecords,
  };
};

export const getCountries = async (): Promise<CountryApi[]> => {
  const { data } = await axiosInstance.get("/Country", {
    headers: getAuthHeader(),
  });
  return data;
};

export const getBaseCurrency = async (): Promise<BaseCurrencyApi> => {
  const { data } = await axiosInstance.get("/Currency/base-currency", {
    headers: getAuthHeader(),
  });
  return data;
};

export const createVisaFee = async (
  payload: CreateVisaFeePayload
): Promise<CreateVisaFeeResponse> => {
  const { data } = await axiosInstance.post("/visa-fee", payload, {
    headers: getAuthHeader(),
  });
  return data;
};

export const getAgeRules = async (): Promise<AgeRuleApi[]> => {
  const res = await axiosInstance.get("/AgeRule/list", {
    headers: getAuthHeader(),
  });
  return res.data.items;
};

export const updateVisaFee = async (
  payload: UpdateVisaFeePayload
): Promise<boolean> => {
  const { data } = await axiosInstance.put("/visa-fee", payload, {
    headers: getAuthHeader(),
  });

  return data.data;
};

export const updateVisaFeeStatus = async (
  publicId: string,
  isActive: boolean
): Promise<boolean> => {
  const { data } = await axiosInstance.put(
    `/visa-fee/${publicId}/${isActive}`,
    {},
    {
      headers: getAuthHeader(),
    }
  );

  return data.data;
};
